import { GirisPage } from './../../giris/giris';
import { KullaniciListePage } from './../kullanici-liste/kullanici-liste';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { PagesProvider } from '../../../providers/pages-provider';

/**
 * Generated class for the YonetimAnaSayfaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-yonetim-ana-sayfa',
  templateUrl: 'yonetim-ana-sayfa.html',
})
export class YonetimAnaSayfaPage {
  menuler=[];
  gunSonu=false;

  constructor(public navCtrl: NavController,
    
     public navParams: NavParams) {
  }

  ionViewDidLoad() {
   this.MenuleriGoruntule();
  }

  Kullanicisayfasi(){
    this.navCtrl.push(KullaniciListePage);
  }
  menuItemClick(item) {
   
    var pagesProvider = new PagesProvider();
    var componentType = typeof item.PAGE_COMPONENT;
    var component;
    if (componentType === "string")
      component = pagesProvider.components[item.PAGE_COMPONENT];
    else
      component = item.PAGE_COMPONENT;
    if (component == GirisPage) {
    //  this.ortak.storeagePersonelCikar();
    }
    this.navCtrl.push(component);
  }
  MenuleriGoruntule() {
    var pagesProvider = new PagesProvider();
    pagesProvider.menuler().then(a => {
      var sonuc = <any>a;
      
        this.menuler = sonuc.YONETIM_MENU;
      })
    
  }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/yonetim-ana-sayfa/yonetim-ana-sayfa.ts